import { Link } from 'react-router-dom'
import cls from 'classnames'

import { TruncatedText } from '../../common'

import styles from './UnityHubRoomNavLinkInline.module.scss'

export const UnityHubRoomNavLinkInline = ({
  to,
  name,
  icon
}: {
  to: string
  name: string
  icon: React.ReactNode
}) => (
  <Link to={to} className={cls(styles.root)}>
    {icon}
    <TruncatedText text={name} />
  </Link>
)
